import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "mb-3 flex gap-2"
};
const _hoisted_2 = ["disabled"];
const _hoisted_3 = {
  class: "max-h-80 overflow-y-auto"
};
const _hoisted_4 = ["onKeyup"];
const _hoisted_5 = {
  key: 1,
  class: "flex-1 text-sm text-slate-700"
};
const _hoisted_6 = {
  class: "flex items-center gap-1 shrink-0"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["onClick"];
import { ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Edit, Delete } from '@element-plus/icons-vue';
import { getTagList, createTag, updateTag, deleteTag } from '@/api/assets';
export default {
  __name: 'AssetTagManageDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:visible', 'refresh'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const list = ref([]);
    const loading = ref(false);
    const newTagName = ref('');
    const newTagColor = ref('#3B82F6');
    const editingId = ref(null);
    const editingName = ref('');
    async function fetchList() {
      loading.value = true;
      try {
        const data = await getTagList();
        list.value = data || [];
      } catch {
        // handled by interceptor
      } finally {
        loading.value = false;
      }
    }
    async function handleCreate() {
      if (!newTagName.value) return;
      try {
        await createTag({
          name: newTagName.value,
          color: newTagColor.value,
          sort: list.value.length
        });
        ElMessage.success('标签已创建');
        newTagName.value = '';
        await fetchList();
        emit('refresh');
      } catch {
        // handled by interceptor
      }
    }
    function startEdit(tag) {
      editingId.value = tag.id;
      editingName.value = tag.name;
    }
    async function handleUpdate(tag) {
      if (!editingName.value) return;
      try {
        await updateTag(tag.id, {
          name: editingName.value,
          color: tag.color,
          sort: tag.sort,
          status: tag.status
        });
        editingId.value = null;
        ElMessage.success('标签已更新');
        await fetchList();
        emit('refresh');
      } catch {
        // handled by interceptor
      }
    }
    async function handleDelete(tag) {
      try {
        await ElMessageBox.confirm(`确定删除标签「${tag.name}」吗？被素材使用的标签无法删除。`, '删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await deleteTag(tag.id);
        ElMessage.success('标签已删除');
        await fetchList();
        emit('refresh');
      } catch {
        // 取消或错误
      }
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_color_picker = _resolveComponent("el-color-picker");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": __props.visible,
        title: "标签管理",
        width: "520px",
        "close-on-click-modal": false,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.$emit('update:visible', $event)),
        onOpen: fetchList
      }, {
        footer: _withCtx(() => [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[4] || (_cache[4] = $event => _ctx.$emit('update:visible', false))
        }, "关闭")]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input, {
          modelValue: newTagName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => newTagName.value = $event),
          placeholder: "新标签名称",
          maxlength: "64",
          class: "flex-1",
          onKeyup: _withKeys(handleCreate, ["enter"])
        }, null, 8, ["modelValue"]), _createVNode(_component_el_color_picker, {
          modelValue: newTagColor.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => newTagColor.value = $event)
        }, null, 8, ["modelValue"]), _createElementVNode("button", {
          type: "button",
          class: "btn-primary btn-sm",
          disabled: !newTagName.value,
          onClick: handleCreate
        }, "添加", 8, _hoisted_2)]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, tag => {
          return _openBlock(), _createElementBlock("div", {
            key: tag.id,
            class: "flex items-center gap-3 py-2.5 px-2 border-b border-slate-50 last:border-0"
          }, [_createElementVNode("span", {
            class: "w-3 h-3 rounded-full shrink-0",
            style: _normalizeStyle({
              backgroundColor: tag.color || '#94a3b8'
            })
          }, null, 4), editingId.value === tag.id ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => editingName.value = $event),
            class: "flex-1 text-sm px-2 py-1 border border-primary-300 rounded outline-none focus:border-primary-500",
            onKeyup: [_withKeys($event => handleUpdate(tag), ["enter"]), _cache[3] || (_cache[3] = _withKeys($event => editingId.value = null, ["escape"]))]
          }, null, 40, _hoisted_4)), [[_vModelText, editingName.value]]) : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(tag.name), 1)), _createElementVNode("div", _hoisted_6, [_createElementVNode("button", {
            type: "button",
            class: "btn-icon",
            title: "编辑",
            onClick: $event => startEdit(tag)
          }, [_createVNode(_component_el_icon, {
            size: 14
          }, {
            default: _withCtx(() => [_createVNode(_unref(Edit))]),
            _: 1
          })], 8, _hoisted_7), _createElementVNode("button", {
            type: "button",
            class: "btn-icon-danger",
            title: "删除",
            onClick: $event => handleDelete(tag)
          }, [_createVNode(_component_el_icon, {
            size: 14
          }, {
            default: _withCtx(() => [_createVNode(_unref(Delete))]),
            _: 1
          })], 8, _hoisted_8)])]);
        }), 128))])), [[_directive_loading, loading.value]])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
};